$(document).ready(function(){            
    $('.testimonials-slider').slick({
        dots: false,
        speed: 1000
    });
});